<template>
  <div class="footerform">
    <div class="footer-content">
      <div class="flag1"></div>
      <div class="flag2"></div>
      <div class="tel-wrapper" @click="clickFooterTel">
        <span class="errortoast" v-if="phoneToast">{{phoneToastMsg}}</span>
        <input type="text" name placeholder="请输入手机号" v-model.trim="formDate.telphone" @keyup="monitorPhone()" @blur="focusLeave()"/>
      </div>
      <div class="code-wrapper">
        <span class="errortoast" v-if="codeToast">{{codeToastMsg}}</span>
        <input type="text" name placeholder="请输入验证码" v-model.trim="formDate.code" @click="clickFooterCode"/>
        <span class="send-code" @click="sendCode()" :style="{background:sendCodeColor}" data-action-name="mas_bottom_code">{{sendcodeBtn}}</span>
      </div>
      <div class="name-wrapper" @click="clickFooterName">
        <span class="errortoast" v-if="nameToast">请输入姓名</span>
        <input type="text" name placeholder="请输入姓名" v-model.trim="formDate.name" data-action-name="mas_bottom_name"/>
      </div>
      <span class="border"></span>
      <div class="grade-wrapper">
        <span class="errortoast" v-if="gradeToast">请选择年级</span>
        <div class="grade-select" @click="choiceGradeShow()" data-action-name="mas_bottom_grade">
          {{gradeName}}
        </div>
        <ul class="grade-list" v-if="gradeListShow">
          <li
            v-for="(value,key) in gradeList"
            :key="key"
            :value="value.value"
            @click="choiceGrade(value.value,value.label)"
          >{{value.label}}</li>
        </ul>
      </div>
      <span class="border"></span>
      <div class="button" @click="submitForm()" data-action-name="mas_bottom_commit">立即预约</div>
    </div>
    <popupform :isPopupFormShow="isPopupFormShow" @popupFormClose="popupFormClose" :success="submitSuccess"></popupform>
  </div>
</template>

<script>
import {sendCodePost, addfeedback} from '@/request/index.js';
import popupform from '@/components/popupform';
import {gradeList} from '@/const/list.js';
import guardian , { LogType }from '@xes/dh-guardian-sdk'
import {saTrack} from '@xes/dh-sensor';

export default {
  name: "footerform",
  components: {
    popupform,
  },
  data() {
    return {
      gradeList,
      gradeName: "年级",
      gradeListShow: false,
      isPopupFormShow: false,
      popupFormShow: false,
      submitSuccess: false,
      sendcodeBtn: "发送验证码",
      sendingCode: false,
      submitFlag: true,
      sendcodeNum: 0,
      formDate: {
        telphone: "",
        grade: "0",
        code: "",
        name: "",
        subject: ""
      },
      timer: "",
      phoneToast: false,
      codeToast: false,
      nameToast: false,
      gradeToast: false,
      toastShow: false,
      toastShowTimer: "",
      phoneToastMsg: "",
      codeToastMsg: "",
      sendCodeColor:""
    };
  },
  watch:{
    toastShow() {
      if(this.toastShow) {
        this.toastShowTimer = setTimeout(() => {
          this.toastShow = false;
          this.phoneToast = false;
          this.codeToast = false;
          this.nameToast = false;
          this.gradeToast = false;
          this.submitFlag = true;
        }, 1000);
      }
    },
  },
  methods:{
    clickFooterTel() {
      saTrack("BottomInputPhone");
    },
    clickFooterCode() {
      saTrack("BottomInputCode");
    },
    clickFooterName() {
      saTrack("BottomInputUserName");
    },
    choiceGradeShow() {
      this.gradeListShow = !this.gradeListShow;
      if(this.gradeListShow) {
        document.addEventListener('click',(e)=>{
          if(e.target.className != 'grade-select'){
              this.gradeListShow = false;
          }
        })
      }
    },
    monitorPhone() {
      if(/^1[345789]\d{9}$/.test(this.formDate.telphone)) {
        this.sendCodeColor = "#E02727";
      }else {
        this.sendCodeColor = "";
      }
    },
    choiceGrade(value,label) {
      saTrack("selectBottomGrade",{str_param1:label});
      this.formDate.grade = value;
      if(value == 0) this.gradeName="年级";
      else this.gradeName = label;
      this.gradeListShow = false;
    },
    popupFormClose(data) {
      this.isPopupFormShow = data;
      this.errorMsgShow = false;
      this.bannerPhone = '';
      this.submitSuccess = false;
    },
    resetForm() {
      this.formDate = {
        telphone: '',
        grade: '0',
        code: '',
        name: '',
        subject: this.subjectName
      };
      this.sendcodeBtn = '发送验证码';
      this.sendingCode = false;
      this.sendCodeColor = "";
      clearInterval(this.timer);
    },
    sendCode() {
      saTrack("BottomSendCode");
      if (!this.formDate.telphone) {
        this.toastShow = true;
        this.phoneToastMsg = "请输入手机号"
         this.phoneToast = true;
        return;
      } else if (!(/^1[345789]\d{9}$/.test(this.formDate.telphone))) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入正确手机号"
        return;
      }
      if (!this.sendingCode) {
        this.sendingCode = true;
        this.sendcodeNum = 60;
        this.sendcodeBtn = "重新发送(60)"
        this.timer = setInterval(() => {
          this.sendcodeNum--;
          this.sendcodeBtn = '重新发送(' + this.sendcodeNum + ')'
          if (this.sendcodeNum === 0) {
            clearInterval(this.timer);
            this.sendingCode = false;
            this.sendcodeBtn = '重新发送';
          }
        }, 1000);
        sendCodePost({
          mobile: this.formDate.telphone
        }).then((res) => {
          if (res.data.error_code === 0) {
            this.toastShow = true;
            this.codeToast = true;
            this.codeToastMsg = res.data.message
          } else {
            this.toastShow = true;
            this.codeToast = true;
            this.codeToastMsg = res.data.message
            clearInterval(this.timer);
            this.sendingCode = false;
            this.sendcodeBtn = '重新发送';
          }
        }).catch(err => err);
      }
    },
    httpResultOperation(res) {
      this.submitFlag = true;
      if (res.data.status === 0) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = res.data.message
      } else if (res.data.status === 1) {
        let data = {
          clue_id:res.data.result.cid
        }
        saTrack("clickBottomFreeOrder",data); 
        this.isPopupFormShow = true;
        this.submitSuccess = true;
        this.submitFlag = false;
        this.gradeListShow = false;
        this.gradeName = "年级"
        this.resetForm();
      }
    },
    submitForm() {
      let data = null;
      if (!this.formDate.telphone) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入手机号";
        this.submitFlag = false;
      }else if (!(/^[1][34578][0-9]{9}$/.test(this.formDate.telphone))) {
        this.toastShow = true;
        this.phoneToast = true;
        this.phoneToastMsg = "请输入正确手机号";
        this.submitFlag = false;

      }
      if (!this.formDate.code) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = "请输入验证码";
        this.submitFlag = false;
      }else if (isNaN(parseInt(this.formDate.code))) {
        this.toastShow = true;
        this.codeToast = true;
        this.codeToastMsg = "请输入正确验证码";
        this.submitFlag = false;
      }
      if (this.formDate.name === '') {
        this.toastShow = true;
        this.nameToast = true;
        this.submitFlag = false;
      }
      if (this.formDate.grade === '0') {
        this.toastShow = true;
        this.gradeToast = true;
        this.submitFlag = false;
        return
      }
      if (this.submitFlag) {
        data = {
          username:this.formDate.name,
          class_id:parseInt(this.formDate.grade),
          mobile:parseInt(this.formDate.telphone),
          code:parseInt(this.formDate.code),
          source_url: window.location.href,
          event: this.$getUrlParam('event') || '10057',
          source: this.$getUrlParam('channel') || '277',
          subject: this.formDate.subject,
        };
        addfeedback(data).then((res) => {
          this.submitFlag = true;
          this.httpResultOperation(res);
        }).catch(err => err);
      }
    },
    focusLeave() {
      guardian.log('click',{action_name: "mas_bottom_phone_number"}, LogType.interaction)
    }
  }
};

</script>
<style scoped lang="scss">
.footerform {
  // width: 100%;
  position: fixed;
  bottom: 0;
  width: 100%;
  min-width: 1200px;
  left: 0;
  height: 60px;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .footer-content {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 11px 0;
    margin: 0 auto;
    box-sizing: border-box;
    .errortoast {
      position: absolute;
      top: -23px;
      padding: 0 10px;
      width: 100px;
      height: 30px;
      background: #E02727;
      font-size: 12px;
      color: #FFFFFF;
      letter-spacing: 0;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
    }
    .errortoast::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 20px;
      width: 0;
      height: 0;
      border: 6px solid #E02727;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
    }
    .flag1 {
      float: left;
      width: 160px;
      height: 129px;
      margin-top: -72px;
      margin-left: -5px;
      background: url("~_img/coursecardimg/footerimg1.png") no-repeat center;
    }    
    .flag2 {
      float: left;
      width: 242px;
      height: 26px;
      margin-top: 4px;
      margin-right: 23px;
      margin-left: -20px;
      background: url("~_img/coursecardimg/footerimg2.png") no-repeat center;
    }
    input {
      width: 90px;
      outline: 0;
      border: none;
      font-size: 14px;
      line-height: 36px;
      letter-spacing: 1px;
      margin-left: 12px;
    }
    .tel-wrapper,
    .code-wrapper,
    .name-wrapper,
    .grade-wrapper {
      height: 36px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      float: left;
      input {
        height: 36px;
      }
    }
    .tel-wrapper {
      width: 157px;
      margin-right: 10px;
      input {
        width: 90%;
      }
    }
    .code-wrapper {
      width: 207px;
      margin-right: 10px;
      .send-code {
        float: right;
        width: 97px;
        height: 30px;
        background: rgba(190, 190, 190, 1);
        border-radius: 2px;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        letter-spacing: 1px;
        text-align: center;
        margin: 3px;
      }
      .send-code:hover {
        cursor: pointer;
      }
    }
    .name-wrapper {
      width: 138px;
      input {
        width: 90%;
      }
    }
    .grade-wrapper {
      width: 77px;
      .grade-select {
        position: relative;
        line-height: 36px;
        box-sizing: border-box;
        letter-spacing: 1px;
        padding-left: 12px;
        border-radius: 2px;
        height: 100%;
        width: 100%;
        font-size: 14px;
        color: #333333;
      }
      .grade-select::before {
      position: absolute;
      top: 12px;
      right: 5px;
      content: '';
      border: 3px solid transparent;
      border-bottom: 5px solid rgba(51, 51, 51, 1);
      border-top: none;
    }
    .grade-select::after{
      position: absolute;
      top: 20px;
      right: 5px;
      content: '';
      border: 3px solid transparent;
      border-top: 5px solid rgba(51, 51, 51, 1);
      border-bottom: none;
    }
    .grade-list {
        width: 77px;
        box-sizing: border-box;
        position: relative;
        left: 0px;
        top: -240px;
        border-radius: 2px;
        border: 1px rgb(30, 144, 255) solid;
        background: #FFF;
        li{
          letter-spacing: 1px;
          padding-left: 12px;
          height: 20px;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
          overflow: hidden;
        }
      }
      .grade-list li:hover {
        color: #FFF;
        background:  rgb(30, 144, 255);
      }
    }
    .border {
      float: left;
      width: 15px;
      height: 36px;
      margin-left: 15px;
      border-left: 1px #999999 solid;
    }
    .button {
      float: left;
      width: 127px;
      height: 36px;
      background: #DF2727;
      border-radius: 2px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 36px;
      letter-spacing: 1px;
      text-align: center;
    }
    .button:hover {
      cursor: pointer;
    }
  }
}
</style>
